import {SVGUtil} from "base/map/svg";

const GeojsonDiscriminatorUtil = {
    applyPointsDiscriminatorStyle(
        layer,
        discriminator,
        discriminatorItems,
        defaultStyle
    ) {
        const discriminatorItemsFound = discriminator.entries
            .filter(discriminatorItem => {
                return discriminatorItems.includes(discriminatorItem.code);
            })
            .filter(discriminatorItem =>
                discriminatorItem.filter(layer.feature.properties[discriminator.field])
            );

        if (discriminatorItemsFound.length > 0) {
            let tooltipContent = "";
            discriminatorItemsFound.forEach(discriminatorItemApplied => {
                tooltipContent += SVGUtil.getCircle(10, discriminatorItemApplied.style);
            });

            // Check if layer has valid bounds (polygon) or position (point)
            let hasValidPosition = false;
            if (layer.getBounds && typeof layer.getBounds === "function") {
                // Polygon - check if bounds are valid
                const bounds = layer.getBounds();
                hasValidPosition = bounds && bounds.isValid();
            } else if (layer.getLatLng && typeof layer.getLatLng === "function") {
                // Point - check if position exists
                const latlng = layer.getLatLng();
                hasValidPosition =
                    latlng && latlng.lat !== undefined && latlng.lng !== undefined;
            }

            if (hasValidPosition) {
                layer.bindTooltip(tooltipContent, {
                    permanent: true,
                    direction: "center",
                    className: "points-container",
                });
            }
            layer.setStyle({
                ...defaultStyle,
            });
        } else {
            layer.closeTooltip();
            layer.setStyle({
                opacity: 0,
                fillOpacity: 0,
            });
        }
    },

    applyDefaultDiscriminatorStyle(
        layer,
        discriminator,
        discriminatorItems,
        defaultStyle
    ) {
        const discriminatorItemApplied = discriminator.entries
            .filter(discriminatorItem => {
                return discriminatorItems.includes(discriminatorItem.code);
            })
            .find(discriminatorItem =>
                discriminatorItem.filter(layer.feature.properties[discriminator.field])
            );

        if (discriminatorItemApplied) {
            layer.setStyle({
                ...defaultStyle,
                ...discriminatorItemApplied.style,
            });
        } else {
            layer.closeTooltip();
            layer.setStyle({
                opacity: 0,
                fillOpacity: 0,
            });
        }
    },

    applyDiscriminatorStyle(layer, discriminator, discriminatorItems, defaultStyle) {
        if (discriminator.style === "points") {
            this.applyPointsDiscriminatorStyle(
                layer,
                discriminator,
                discriminatorItems,
                defaultStyle
            );
        } else {
            this.applyDefaultDiscriminatorStyle(
                layer,
                discriminator,
                discriminatorItems,
                defaultStyle
            );
        }
    },
};

export default GeojsonDiscriminatorUtil;
